import { render, staticRenderFns } from "./skill-phase.vue?vue&type=template&id=53fad698&scoped=true"
import script from "./skill-phase.vue?vue&type=script&lang=js"
export * from "./skill-phase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fad698",
  null
  
)

export default component.exports